import { HttpResponse } from '@asset-metrix/poco-api-client-js';

export async function getMessageFromResponse(
  response: HttpResponse<unknown, unknown>
): Promise<string | undefined> {
  const data = await response.json();
  return data.message;
}
